import React from 'react'
import PropTypes from 'prop-types'
import firebase from 'helpers/firebase'

import { withStyles } from 'material-ui/styles'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import { CircularProgress } from 'material-ui/Progress'
import TextField from 'material-ui/TextField'
import { InputAdornment } from 'material-ui/Input'
import IconButton from 'material-ui/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import ParticleBackground from 'components/ParticleBackground'

import { isValidEmail } from 'helpers/validation'
import styles from 'styles/screens/Login'

class Login extends React.Component {
  state = {
    email: '',
    emailInvalid: false,
    password: '',
    passwordInvalid: false,
    showPassword: false,
    processing: false,
    authFailed: false
  }

  handleChange = key => event => {
    this.setState({
      [key]: event.target.value,
      [key + 'Invalid']: false
    })
  }

  handleMouseDownPassword = event => {
    event.preventDefault()
  }

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword })
  }

  triggerSubmit = () => {
    document.getElementById('loginFormSubmit').click()
  }

  handleSubmit = event => {
    event.preventDefault()
    let validInput = true

    if (!isValidEmail(this.state.email)) {
      validInput = false
      this.setState({ emailInvalid: true })
    }

    if (this.state.password.length === 0) {
      validInput = false
      this.setState({ passwordInvalid: true })
    }

    if (validInput) {
      this.setState({ processing: true, authFailed: false })
      firebase
        .auth()
        .signInWithEmailAndPassword(this.state.email, this.state.password)
        .catch(error => {
          this.setState({ processing: false, authFailed: true })
        })
    }
  }

  render() {
    const { classes, title, loading } = this.props
    const {
      email,
      emailInvalid,
      password,
      passwordInvalid,
      showPassword,
      processing,
      authFailed
    } = this.state

    //TODO: Convert login page to use the EditDialog component
    return (
      <ParticleBackground>
        <Typography variant="headline" className={classes.title}>
          {title}
        </Typography>
        <Card className={classes.card}>
          {authFailed && (
            <Typography className={classes.errorMessage}>
              Authentication failed
            </Typography>
          )}
          <CardContent>
            {processing || loading ? (
              <div className={classes.loadingWrapper}>
                <CircularProgress size={60} />
              </div>
            ) : (
              <form
                className={classes.form}
                noValidate
                onSubmit={this.handleSubmit}
              >
                <TextField
                  id="email"
                  label="Email"
                  error={emailInvalid}
                  helperText={emailInvalid && 'Invalid email address'}
                  value={email}
                  type="email"
                  onChange={this.handleChange('email')}
                  fullWidth
                  margin="normal"
                />

                <TextField
                  id="password"
                  label="Password"
                  error={passwordInvalid}
                  helperText={passwordInvalid && 'Password cannot be blank'}
                  value={password}
                  type={showPassword ? 'text' : 'password'}
                  onChange={this.handleChange('password')}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                  fullWidth
                  margin="normal"
                />

                <input
                  id="loginFormSubmit"
                  className={classes.submit}
                  type="submit"
                />
              </form>
            )}
          </CardContent>
          {!processing &&
            !loading && (
              <CardActions className={classes.actions}>
                <Button
                  variant="raised"
                  color="secondary"
                  onClick={this.triggerSubmit}
                >
                  Login
                </Button>
              </CardActions>
            )}
        </Card>
      </ParticleBackground>
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Login)



// WEBPACK FOOTER //
// ./src/views/Login.jsx